<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      fixed
      width="600"
      right
      temporary
      stateless
      style="z-index: 100"
    >
      <div class="drawer-wrapper">
        <v-flex
          class="py-3 px-5 d-flex align-center border-bottom drawer-header"
        >
          <div
            class="dialog-custom-header text-uppercase custom-header-blue-text white-background"
          >
            <span style="font-size: 18px"> Properties </span>
          </div>
          <v-spacer></v-spacer>
          <v-btn
            depressed
            tile
            class="light darken-4 me-2"
            v-on:click="$emit('close', true)"
            >Cancel</v-btn
          >
          <v-btn
            tile
            depressed
            color="white--text"
            v-on:click="saveProperties"
            :disabled="!formValid"
            class="cyan"
            >Save</v-btn
          >
        </v-flex>
        <v-form ref="propertiesForm" v-model="formValid">
        <div class="drawer-content pt-5">
          <div class="form-grp px-5 mb-4">
            <div class="d-flex pb-1">
              <label class="red--text fw-500">Field label</label>
            </div>
            <v-text-field
              depressed
              hide-details="auto"
              outlined
              dense
              filled
              solo
              flat
              v-model="properties.label"
              maxlength="200"
              counter="200"
              :rules="[
                validateRules.required(properties.label, 'Field label'),
                validateRules.maxLength(properties.label, 'Field label', 200),
              ]"
            ></v-text-field>
          </div>
          <div class="form-grp px-5 mb-4">
            <div class="d-flex pb-1">
              <label class="fw-500">Instructions</label>
            </div>
            <TextAreaField
              v-model="properties.instructions"
              auto-grow
              dense
              filled
              solo
              flat
              color="cyan"
              row-height="20"
              counter="200"
            ></TextAreaField>
          </div>

          <div>
            <div class="form-grp px-5 mb-4">
              <div class="d-flex pb-3">
                <label class="fw-500">Choice</label>
              </div>
              <ul>
                <li
                  class="d-flex mb-5"
                  v-for="(item, index) in properties.choices"
                  :key="index"
                >
                  <v-text-field
                    depressed
                    hide-details="auto"
                    outlined
                    dense
                    filled
                    solo
                    flat
                    :placeholder="item.label"
                    v-model="item.label"
                    maxlength="100"
                    minlength="3"
                    :rules="[validateRules.required(item.label, 'Choice')]"
                  ></v-text-field>
                  <v-icon
                    class="cursor-pointer mx-1 success--text"
                    v-on:click="addNew(index)"
                    >mdi-plus-circle</v-icon
                  >
                  <v-icon
                    class="cursor-pointer mx-1 red--text"
                    v-on:click="remove(index)"
                    >mdi-minus-circle</v-icon
                  >
                </li>
              </ul>
            </div>
          </div>
          <template>
            <div class="form-grp px-5 mb-4">
              <div class="d-flex pb-1">
                <label class="fw-500">Validation</label>
              </div>
              <v-radio-group
                v-model="properties.validation_mandatory"
                hide-details
                class="mt-0"
              >
                <v-radio label="All Mandatory" value="1"></v-radio>
                <v-radio value="2">
                  <template v-slot:label>
                    <div class="d-flex align-center">
                      <div>Select Atleast</div>
                      <div class="mx-2">
                        <v-text-field
                          depressed
                          hide-details
                          outlined
                          dense
                          filled
                          solo
                          flat
                          v-model="properties.select_atleast"
                        ></v-text-field>
                      </div>
                    </div>
                  </template>
                </v-radio>
                <v-radio label="Non Mandatory" value="3"></v-radio>
              </v-radio-group>
            </div>
            <div class="form-grp px-5 mb-4">
              <div class="d-flex pb-1">
                <label class="fw-500">Column</label>
              </div>
              <v-select
                dense
                filled
                solo
                flat
                :items="columnItems"
                placeholder="Column"
                hide-details
                color="cyan"
                v-model="properties.column"
              />
            </div>
          </template>
        </div>
        </v-form>
      </div>
    </v-navigation-drawer>
  </div>
</template>
<script>
import ValidationMixin from "@/core/plugins/validation-mixin";

export default {
  mixins: [ValidationMixin],
  name: "FormBuilderDrawer",
  props: {
    drawer: {
      type: Boolean,
      default: false,
    },
    filedData: {
      type: Array,
      default: new Array(),
    },
    propertiesData: {
      type: Object,
      default: new Object(),
    },
    type: {
      type: String,
      default: null,
    },
  },
  watch: {
    propertiesData: {
      handler(param) {
        this.properties = param;
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      columnItems: [
        {
          text: "Full width (width:100%)",
          value: "12",
        },
        {
          text: "Two Column (width:50%)",
          value: "6",
        },
        {
          text: "Three Column (width:33%)",
          value: "4",
        },
      ],
      ratingCount: [1, 2, 3, 4, 5],
      ratingType: ["Star", "Lightning", "Shield", "Heart", "Flag"],
      dialog: false,
      editorData: "<p>Single Line</p>",
      editorConfig: {},
      properties: {},
      range_format: ["Digits", "Values"],
      inputTypeValue: ["Any Character", "letter Only", "Letter and Numbers"],
      range: [1, 2, 3, 4, 5],
      time_format: ["AM", "PM"],
      hh: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      fileSize: ["KB", "MB"],
      mm: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
        21, 22, 23, 24, 25, 26, 27, 28, 29, 30,
      ],
      domains: [
        "Allow All Domains",
        "Allow Specific Domains",
        "Restrict Specific Domains",
      ],
    };
  },
  methods: {
    saveProperties() {
      if (this.$refs.propertiesForm.validate()) {
        this.$emit("success", this.properties);
      }
    },
    addNew(index) {
      let len = this.properties.choices.length;
      this.properties.choices.splice(index + 1, 0, {
        label: null,
        check_status: false,
        value: len,
      });
    },
    remove(index) {
      this.properties.choices.splice(index, 1);
    },
  },
  components: {},
};
</script>
